module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-refund-detail"
  }, [_c('row', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.fullLoading),
      expression: "fullLoading"
    }],
    staticClass: "sl-col-4"
  }, [_c('div', {
    staticClass: "sl-form"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.trxId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.trxId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.cTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.createTime))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.ptId')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.businessId))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.pType')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.payType))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.customer')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.customer))])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.fee')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.serviceFee))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.rAmount')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.refundAmount))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.settled')))])])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "border-line",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.sTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.settleTime))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('h3', [_vm._v(_vm._s(_vm.$t('Views.RefundDetail.form.rComplete')) + ": " + _vm._s(_vm.form.refundStatusTxt))])])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm.form.refundStatus == '12' ? _vm.$t('Views.RefundDetail.form.failedTime') : _vm.$t('Views.RefundDetail.form.completeTime')) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.form.modifyTime))])])])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "el-button",
      "to": {
        name: 'Refund'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.$ga.event('Link', 'Back', 'Refund details')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Functional.back')))])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-18b2b875!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/refunds/view-detail.vue
// module id = 1083
// module chunks = 1